"use strict";
import { Theme } from "../Theme.dev.js";
import coreStyles from "./theme.css.js";
Theme.registerThemeFragment("express", "system", coreStyles);
//# sourceMappingURL=core.dev.js.map
